class ChatError extends Error {
  constructor(content) {
    content = content || {}
    super(content.label || "")
    this.content = content
    this.name = "ChatError"
  }
}

export default ChatError
